var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.tipTapEditor
    ? _c("div", { staticClass: "menu-bar-container" }, [
        _c(
          "div",
          {
            staticClass:
              "menu-bar px-2 d-flex flex-wrap align-items-center justify-content-between"
          },
          [
            _c(
              "div",
              { staticClass: "button-list d-flex align-items-center" },
              [
                _vm.extended
                  ? _c(
                      "label",
                      {
                        staticClass: "menu-button",
                        class: {
                          "is-active": _vm.editor.isActive("heading", {
                            level: 3
                          })
                        },
                        on: { click: _vm.handleHeadingClick }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-font-size.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "menu-button",
                    class: { "is-active": _vm.editor.isActive("bold") },
                    on: { click: _vm.handleBoldClick }
                  },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-bold.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "menu-button",
                    class: { "is-active": _vm.editor.isActive("strike") },
                    on: { click: _vm.handleStrikeClick }
                  },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-strike.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "menu-button",
                    class: { "is-active": _vm.editor.isActive("italic") },
                    on: { click: _vm.handleItalicClick }
                  },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-italic.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "menu-button",
                    class: { "is-active": _vm.editor.isActive("bulletList") },
                    on: { click: _vm.handleBulletListClick }
                  },
                  [
                    _c("InlineSvg", {
                      attrs: { src: "/images/icons/ic-list.svg" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.showImage
                  ? _c(
                      "label",
                      {
                        staticClass: "menu-button",
                        on: { click: _vm.addImage }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-image.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showVideoEmbed
                  ? _c(
                      "label",
                      {
                        staticClass: "menu-button",
                        on: { click: _vm.addLoomVideo }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-video.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showLink
                  ? _c(
                      "label",
                      {
                        staticClass: "menu-button",
                        on: { click: _vm.setLink }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-link.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showCountdownTimer
                  ? _c(
                      "label",
                      {
                        staticClass: "menu-button",
                        on: { click: _vm.addCountdownTimer }
                      },
                      [
                        _c("InlineSvg", {
                          attrs: { src: "/images/icons/ic-clock.svg" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showGenerateWithAI
                  ? _c(
                      "AppButton",
                      {
                        staticClass:
                          "inverse tiptap-editor-ai-button ml-0 pl-0",
                        attrs: {
                          name: "tiptap-editor-ai-assistance",
                          size: "sm",
                          link: "",
                          type: "button",
                          icon: "images/icons/ic-ai-generate.svg",
                          loading: _vm.isAISuggestionLoading,
                          disabled: _vm.isAISuggestionLoading,
                          color: _vm.error ? "danger" : "primary"
                        },
                        on: { click: _vm.toggleAIPrompt }
                      },
                      [
                        _c("span", { staticClass: "ai-button-text" }, [
                          _vm._v("Generate with AI")
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.showDone
              ? _c(
                  "AppButton",
                  {
                    staticClass: "inverse done-button",
                    attrs: {
                      name: "finished-editing-toolbar-button",
                      size: "sm",
                      pill: "",
                      type: "button",
                      outline: ""
                    },
                    on: { click: _vm.doneEditing }
                  },
                  [_vm._v("\n\t\t\tDone\n\t\t")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fart
              ? _c(
                  "div",
                  { staticClass: "d-flex px-0 ml-auto" },
                  [
                    _vm.showPersonalize &&
                    !_vm.showPersonalizeAtBottom &&
                    _vm.variableItemsData
                      ? _c(
                          "AppDropdownMenu",
                          {
                            staticClass: "flex-auto",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function() {
                                    return _vm._l(
                                      _vm.sortedVariableItemsData,
                                      function(item) {
                                        return _c(
                                          "button",
                                          {
                                            key: item.id,
                                            staticClass: "dropdown-item",
                                            attrs: { type: "button" },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleVariableItemClick(
                                                  item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t" +
                                                _vm._s(item.name) +
                                                "\n\t\t\t\t\t"
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  },
                                  proxy: true
                                }
                              ],
                              null,
                              false,
                              2950752243
                            )
                          },
                          [
                            _c(
                              "AppButton",
                              {
                                staticClass: "inverse",
                                attrs: {
                                  name: "tiptap-editor-personalize",
                                  size: "sm",
                                  outline: "",
                                  type: "button",
                                  icon: "images/icons/ic-plus.svg"
                                }
                              },
                              [_vm._v("\n\t\t\t\t\tPersonalize\n\t\t\t\t")]
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showProductList
                      ? _c(
                          "AppButton",
                          {
                            staticClass: "inverse",
                            attrs: {
                              name: "tiptap-editor-product-link",
                              size: "sm",
                              outline: "",
                              type: "button",
                              icon: "images/icons/ic-link.svg"
                            },
                            on: { click: _vm.openProductSelectionModal }
                          },
                          [_vm._v("\n\t\t\t\tAdd Product Link\n\t\t\t")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.showAIPrompt
                      ? _c("AIPromptBox", {
                          directives: [
                            {
                              name: "on-click-outside",
                              rawName: "v-on-click-outside",
                              value: _vm.closeAIPrompt,
                              expression: "closeAIPrompt"
                            }
                          ],
                          on: { requestAIAssistance: _vm.requestAIAssistance }
                        })
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }